// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3cewW","footer":"ChangeClinic_footer__3dOmy"};